import { Nullable } from '@redngapps/shared/types';

/**
 * Holds the per-instance runtime config, loaded once during `APP_INITIALIZER` by
 * {@link AbstractRuntimeConfigInitializerService}. Apps subclass this with their concrete config
 * type and an `@Injectable({ providedIn: 'root' })` decorator so it can be injected as a token.
 */
export abstract class AbstractRuntimeConfigService<T> {
  private config: Nullable<T> = null;

  setConfig(config: T): void {
    this.config = config;
  }

  getConfig(): Nullable<T> {
    return this.config;
  }
}
